/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CalibrationItem
 */
export interface CalibrationItem {
    [key: string]: any | any;
    /**
     * 
     */
    slope?: number | null;
    /**
     * 
     */
    xIntercept?: number | null;
    /**
     * 
     */
    r2?: number | null;
}

/**
 * Check if a given object implements the CalibrationItem interface.
 */
export function instanceOfCalibrationItem(value: object): value is CalibrationItem {
    return true;
}

export function CalibrationItemFromJSON(json: any): CalibrationItem {
    return CalibrationItemFromJSONTyped(json, false);
}

export function CalibrationItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalibrationItem {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        'slope': json['slope'] === undefined ? undefined : json['slope'] === null ? null : json['slope'],
        'xIntercept': json['x_intercept'] === undefined ? undefined : json['x_intercept'] === null ? null : json['x_intercept'],
        'r2': json['R2'] === undefined ? undefined : json['R2'] === null ? null : json['R2'],
    };
}

export function CalibrationItemToJSON(json: any): CalibrationItem {
    return CalibrationItemToJSONTyped(json, false);
}

export function CalibrationItemToJSONTyped(value?: CalibrationItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
            ...value,
        'slope': value['slope'],
        'x_intercept': value['xIntercept'],
        'R2': value['r2'],
    };
}

